import React, { useState, useRef, useEffect } from 'react';
import Loader from 'components/sales/Loader/loader';
const RedirectPage = ({ match }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
  }, []);

  localStorage.setItem('redirect', match.params.id);
  if(localStorage.getItem('redirect')){
    window.location.href="/dashboard/vendorPaymentRequestApprovalPage/"+match.params.id;
  }

  return (
    <>
        <Loader isLoading={isLoading} />
    </>
  );
};

export default RedirectPage;
